import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import _ from 'lodash';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';

import metadata from './MLUnderlyingPoliciesListPopup.metadata.json5';
import messages from './MLUnderlyingPoliciesListPopup.messages';
import styles from './MLUnderlyingPoliciesListPopup.module.scss';

import { IntlContext } from '@jutro/legacy/locale';

const MLUnderlyingPoliciesListPopup = (props) => {
    const {
        underlyingPolicies,
        editUnderlyingPolicy,
        removeUnderlyingPolicy,
        onCancel,
        isUMB_NP,
        viewModelService
    } = props;

    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const isAMP = appConfig.portalCode === 'AMP';
    const POLICYTYPE_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('PUPULPolicyType_PUE');
    const CARRIER_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('ULCarrier_PUE');

    const getFormattedDateString = useCallback((gwDateVal) => {
        const date = LocalDateUtil.toMidnightDate(gwDateVal);
        return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' });
    }, [intl]);

    const getTypeKeyDescription = useCallback((typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    }, [translator]);

    const editUlPolicy = useCallback((callbackProps) => {
        editUnderlyingPolicy(underlyingPolicies[callbackProps.index], onCancel);
    }, [editUnderlyingPolicy, underlyingPolicies, onCancel]);

    const removeUlPolicy = useCallback((callbackProps) => {
        removeUnderlyingPolicy(underlyingPolicies[callbackProps.index], onCancel);
    }, [removeUnderlyingPolicy, underlyingPolicies, onCancel]);

    const generateOverrides = () => {
        const overrides = underlyingPolicies.map((policy, index) => {
            let carrier = null;
            if (policy.carrier) {
                carrier = getTypeKeyDescription(CARRIER_TYPELIST.getCode(policy.carrier).name);
                if (carrier === 'Other') {
                    carrier = policy.otherCarrier;
                }
            }

            return {
                [`policyTypeCell${index}`]: {
                    className: `cell ${_.get(policy, 'error', false) ? 'error-help-text font-weight-bold' : ''}`
                },
                [`policyTypeErrorAlertIcon${index}`]: {
                    visible: _.get(policy, 'error', false)
                },
                [`policyType${index}`]: {
                    content: policy.policyType ? !(isUMB_NP && policy.policyType === 'HO') ? getTypeKeyDescription(POLICYTYPE_TYPELIST.getCode(policy.policyType).name) : translator({id: 'property', defaultMessage: "Property"})  : null
                },
                [`policyCarrier${index}`]: {
                    content: carrier
                },
                [`policyEffectiveDate${index}`]: {
                    content: policy.effectiveDate ? getFormattedDateString(policy.effectiveDate) : null
                },
                [`policyExpirationDate${index}`]: {
                    content: policy.expirationDate ? getFormattedDateString(policy.expirationDate) : null
                },
                [`policyInsured${index}`]: {
                    content: policy.nameOfInsured !== 'Other' ? policy.nameOfInsured : policy.otherInsured
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrides = {
        underlyingPoliciesHeader: {
            content: translator(isAMP ? messages.yourPolicies : messages.policies)
        },
        underlyingPoliciesDescription: {
            content: translator(isAMP ? messages.showPoliciesIncluded : messages.foundPoliciesToBeIncluded)
        },
        policiesTableContainer: {
            visible: underlyingPolicies.length > 0
        },
        policiesIterable: {
            data: underlyingPolicies
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveCallbackMap : {
            editUlPolicy,
            removeUlPolicy
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );

};

MLUnderlyingPoliciesListPopup.propTypes = {
    underlyingPolicies: PropTypes.array,
    editUnderlyingPolicy: PropTypes.func,
    removeUnderlyingPolicy: PropTypes.func,
    onCancel: PropTypes.func
};

export default MLUnderlyingPoliciesListPopup;
